import { NoteDto } from '@groundfloor-platform/mgmt-service-g-sdk';
import { forwardRef, useState } from 'react';
import { Popper, PopperProps, Tooltip } from '@mui/material';
import { useDeliveriesRequiringAttentionTooltipStyles } from '../../reports/deliveries-requiring-attention/list/components/deliveries-requiring-attention-tooltip.styles';
import { Colors } from '../../../ui/theme/colors';
import { Note } from '../../../ui/components/pure/icons/Note.icon';

export interface NoteProps {
  note: NoteDto;
  iconSize?: string;
  tooltip?(): JSX.Element;
  hideTooltip?: boolean;
}

export function NoteIcon({ tooltip, hideTooltip, ...rest }: NoteProps) {
  const [open, setOpen] = useState(false);

  // If no tooltip has been provided then use the default tooltip
  if (!tooltip) tooltip = () => <span>Note</span>;

  const classes = useDeliveriesRequiringAttentionTooltipStyles({});

  return (
    <Tooltip
      open={open && !hideTooltip}
      onOpen={() => setOpen(true && !hideTooltip)}
      onClose={() => setOpen(false)}
      classes={{ tooltip: classes.tooltip }}
      title={tooltip()}
      slots={{
        popper: FixedWidthPopper
      }}
      slotProps={{
        popper: {
          disablePortal: true,
          popperOptions: {
            strategy: 'fixed',
            modifiers: [
              {
                name: 'preventOverflow',
                enabled: true,
                options: { boundariesElement: 'window' }
              },
              {
                name: 'flip',
                enabled: false
              }
            ]
          }
        }
      }}
    >
      <NoteChildren {...rest} />
    </Tooltip>
  );
}

const FixedWidthPopper = function (props: PopperProps) {
  return <Popper {...props} style={{ width: '320px' }} />;
};

// The MUI tooltip requires that its ref and child props (it adds props to its children) are passed down to the native element being rendered
// This forward ref does this, while extracting the custom component props from the props before forwarding them to prevent React errors
const NoteChildren = forwardRef<HTMLDivElement, Omit<NoteProps, 'tooltip'>>(function NoteChildren(
  { note, iconSize, ...rest },
  ref
) {
  const SVG = Note;
  const color = Colors.timelineGray;
  return (
    <div {...rest} ref={ref}>
      <SVG
        key={note.id}
        style={{
          width: iconSize ? iconSize : '34px',
          height: iconSize ? iconSize : '34px',
          color,
          marginRight: '3px'
        }}
      />
    </div>
  );
});
